import { TransmissionSystemOperatorResource } from 'app/_resources/transmission-system-operator.resource';
import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { getCognitoTokens } from '../../angular/utils/cognito';
import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('FcfsBookingStageOneCtrl', FcfsBookingStageOneCtrl);

    function FcfsBookingStageOneCtrl(
        $log,
        $scope,
        Fcfs,
        GENERAL_ERROR,
        authService,
        fcfsBookingService,
        NetworkPoint: NetworkPointResource,
        TransmissionSystemOperator: TransmissionSystemOperatorResource,
        networkPointSearchService
    ) {
        var vm = this;

        vm.submit = submit;
        vm.parseSelection = parseSelection;
        vm.isLoggedIn = authService.isLoggedIn();
        vm.user = authService.getLoggedInUser();
        vm.generalError = GENERAL_ERROR;
        vm.INPUT_ADDON = networkPointSearchService.INPUT_ADDON;

        vm.isCognitoLoggedIn = false;
        getCognitoTokens().then(
            (tokens) => (vm.isCognitoLoggedIn = Boolean(tokens))
        );

        init();

        $scope.$on(fcfsBookingService.BROADCAST.WIZARD_RESTART, function () {
            init();
        });

        var networkPoint = fcfsBookingService.getNetworkPoint();
        if (
            !angular.isUndefined(networkPoint) &&
            !angular.isUndefined(networkPoint.name)
        ) {
            getStageOneDataObject(networkPoint);
            fcfsBookingService.setNetworkPoint({});
        }

        function init() {
            vm.ui = {
                generalError: false
            };
            fcfsBookingService.resetAllStagesAfter(1);
            vm.data = fcfsBookingService.getStageOne();
        }

        function getStageOneDataObject(netPoint) {
            NetworkPoint.get(
                { id: netPoint.id },
                function (res) {
                    vm.data.selectedNetworkPoint = res;

                    if (!angular.isUndefined(res.tso0Id)) {
                        TransmissionSystemOperator.get(
                            { id: res.tso0Id, detailLevel: 'PUBLIC' },
                            function (res) {
                                vm.data.tso0 = res;
                            },
                            function (err) {
                                return generalError(err);
                            }
                        );
                    } else {
                        delete vm.data.tso0;
                    }
                    if (!angular.isUndefined(res.tso1Id)) {
                        TransmissionSystemOperator.get(
                            { id: res.tso1Id, detailLevel: 'PUBLIC' },
                            function (res) {
                                vm.data.tso1 = res;
                            },
                            function (err) {
                                return generalError(err);
                            }
                        );
                    } else {
                        delete vm.data.tso1;
                    }

                    vm.ui.generalError = false;
                    fcfsBookingService.setStageOne(vm.data);
                    $scope.wizard.goToNextStage();
                    return true;
                },
                function (err) {
                    return generalError(err);
                }
            );
        }

        function submit(form: ng.IFormController) {
            if (!form.$valid) {
                $scope.wizard.goToTop();
                return false;
            }
            getStageOneDataObject(vm.data.selectedNetworkPoint);
        }

        function parseSelection(networkPoint) {
            vm.data.selectedNetworkPoint = networkPoint;
        }

        function generalError(err) {
            vm.ui.generalError = true;
            $log.error(err);
            return false;
        }
    }
})();
